<div class="spinnerWrapper">
  <mat-progress-spinner [color]="_color" [mode]="_mode" [value]="_value">
  </mat-progress-spinner>
</div>
